"use client"

import { useGetUserPopups } from "@bullseye/components"

import { useEventAttendanceCapture } from "../../hooks/useEventAttendanceCapture"

export const PostLoginPopup = () => {
  const { data: userPopups } = useGetUserPopups()

  useEventAttendanceCapture(userPopups)

  return <></>
}
